/**
 * Validates if a password meets the security requirements.
 * Password must contain:
 * - At least 8 characters
 * - At least one uppercase letter
 * - At least one lowercase letter
 * - At least one number
 *
 * @param {string} password - The password to validate
 * @returns {boolean} True if password meets requirements, false otherwise
 */
export function validatePasswordRequirements(password) {
  if (!password) return false;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  return passwordRegex.test(password);
}
